<script setup>
import { computed, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { Checkbox } from 'vant'

const emit = defineEmits(['checked'])

const store = useStore()
const checked = ref(false)

watchEffect(() => {
  emit('checked', checked.value)
})

const readContent = computed(() => {
  return store.getters.getQuesInfo.readContent
})
</script>
<template>
  <Checkbox class="check-box" v-model="checked" shape="square">
    <p v-html="readContent"></p>
  </Checkbox>
</template>
<style lang="scss" scoped>
.check-box {
  margin: 0 30px;
  margin-top: 60px;
  font-size: 24px;
}
</style>

